/**
 * Indicators hidden from the Lens indicator breakdown.
 *
 * Gold scores risk-factor review three ways per condition: "<X> Risk Factors
 * Positive", "<X> Risk Factors Negative", and the "<X> Risk Factor Analysis"
 * roll-up. Only the roll-up is shown as a row; the Positive / Negative
 * components are inputs and clutter the list. This is display-only: hidden
 * rows still count toward every score exactly as the API computes them, so
 * RSQ math stays identical across the app.
 */

const COMPONENT_ID_RE = /_risk_factors?_(positive|negative)$/;
const COMPONENT_NAME_RE = /\brisk factors?\s+(positive|negative)$/;

/**
 * True for a "<X> Risk Factors Positive / Negative" component indicator.
 * `indicatorId` accepts the snake_case gold id or the API's hyphenated slug.
 */
export const isHiddenIndicator = (
  name: string | null | undefined,
  indicatorId?: string | null,
): boolean => {
  const id = (indicatorId ?? '').trim().toLowerCase().replace(/-/g, '_');
  if (id && COMPONENT_ID_RE.test(id)) return true;
  const label = (name ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
  return label.length > 0 && COMPONENT_NAME_RE.test(label);
};
